import React from 'react';
import {useSelector} from 'react-redux';

import useFwuBackgroundCheckEnabled from '@/hooks/fwu/useFwuBackgroundCheckEnabled';
import {selectIsFwuAvailable} from '@/state/selectors/fwu';

import UpdateAvailableBannerView from './UpdateAvailableBannerView';

const UpdateAvailableBanner = (props) => {
    const isFwuAvailable = useSelector(selectIsFwuAvailable);
    const isFwuCheckEnabled = useFwuBackgroundCheckEnabled();

    return isFwuAvailable && isFwuCheckEnabled ? <UpdateAvailableBannerView {...props} /> : null;
};

export default UpdateAvailableBanner;
